
    <div class="col-lg-6 col-xs-12">

        <div class="panel panel-default">
            <div class="panel-body">

    <div>
      <nvd3 [options]="options" [data]="data"></nvd3>
    </div>

  </div>
 </div>

</div>




// WEBPACK FOOTER //
// ./src/app/report/charts/box-plot-chart/box-plot-chart.component.html